export const RecapLeaveHeader = {
    title: "Suivi activité mensuelle",
    submodules: [

    ],
  };
  
  function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
  }